import { render, staticRenderFns } from "./PlayerAddForm.vue?vue&type=template&id=3d2b9ca5&"
import script from "./PlayerAddForm.vue?vue&type=script&lang=js&"
export * from "./PlayerAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports